import {
    Box,
    Button,
    Chip,
    ExpansionPanel, ExpansionPanelDetails,
    ExpansionPanelSummary,
    Grid,
    IconButton, makeStyles,
    Typography
} from "@material-ui/core";
import AddBoxIcon from "@material-ui/icons/AddBox";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import _ from "lodash";
import RenderInput from "../TrafficSource/RenderInput";
import React, {useState} from "react";
import theme from "../../styles/theme";
import useStyles from "../../styles/styles";
import useTrafficStyles from "../../styles/trafficStyles";

const useExpanderListStyle = makeStyles({
    root: {
        border: '1px solid',

        '& .MuiExpansionPanelSummary-root': {
            padding: theme.spacing(0, 2, 0, 1),
        },
    },
    removeButton: {
        cursor: 'pointer',
        pointerEvents: 'all'
    },
});

const defaultReadOnlyValueGenerator = (item) => {
    return _.isNil(item.value) || item.value === '' ? 'N/A' : item.value
}

const ExpanderList = ({listTitle, listType, idPrefix, editView, handleFieldChange, handleSwitchChange, fieldData, graphqlData, inputs, setInputs, addRow, deleteRow, showDefaultStyles = true, readOnlyValueGenerator = defaultReadOnlyValueGenerator}) => {
    const classes = useStyles();
    const trafficClasses = useTrafficStyles();
    const [expandedPanelsArr, setExpandedPanelsArr] = useState([]);
    const scheduleClasses = useExpanderListStyle();

    return (
        <Box className={`${showDefaultStyles  ? classes.filterBox : ''} ${showDefaultStyles ? trafficClasses.panelBox : ''}`} style={{marginTop: '10px'}}>
            {listTitle ? (
                <Chip
                    label={listTitle}
                    className={classes.filterSectionLabels}
                />
            ) : null}
            {editView ? (
                <Button
                    style={{ float: 'left' }}
                    variant="contained"
                    className={classes.addButton}
                    onClick={() => addRow(idPrefix)}
                    size="small"
                >
                    Add Row <AddBoxIcon/>
                </Button>
            ) : null}
            <Grid container direction="row" alignItems="flex-start" spacing={2}>
                {fieldData && fieldData.length ? (
                    <Grid item xs={12} style={{ padding: '10px 0'}}>
                        {fieldData.map((rows, idx) => {
                            let isDeleted = rows && rows.length && rows.filter(obj => obj.delete) || [];
                            if(isDeleted.length) {
                                return null;
                            }
                            const isExpanded = expandedPanelsArr.length ? expandedPanelsArr.includes(idx) : false;
                            return (
                                <ExpansionPanel
                                    key={idx.toString()}
                                    id={`${idPrefix}-${idx}`}
                                    expanded={isExpanded}
                                    className={scheduleClasses.root}
                                    onChange={(e, bool) => {
                                        if (bool) {
                                            setExpandedPanelsArr(expandedPanelsArr => [...expandedPanelsArr, idx]);
                                        } else {
                                            if (expandedPanelsArr.includes(idx)) {
                                                setExpandedPanelsArr(expandedPanelsArr.filter(panel => panel !== idx));
                                            }
                                        }
                                    }}
                                >
                                    <ExpansionPanelSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                    >
                                        <Grid
                                            container
                                            direction="row"
                                            alignItems="center"
                                            spacing={3}
                                        >
                                            <Grid container key={idx.toString()} style={{ margin: '10px 0'}}>
                                                <Grid item xs={12} md={3}>
                                                    <Box display="flex" flexDirection="row" alignItems="center">
                                                        <Box display="flex" flexDirection="column" alignItems="center">
                                                            {!editView ? (
                                                                <IconButton
                                                                    className={scheduleClasses.removeButton}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                    }}>
    
                                                                </IconButton>
                                                            ) : (
                                                                <IconButton
                                                                    className={scheduleClasses.removeButton}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        deleteRow(idx, idPrefix);
                                                                    }}>
                                                                    <RemoveCircleIcon/>
                                                                </IconButton>
                                                            )}
                                                        </Box>
                                                        <Box textAlign="left">
                                                            <Typography variant="body1">
                                                                <strong>{isExpanded ? `Close ${listType}` : `View ${listType}`}</strong>
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                                {!isExpanded ? (
                                                    <Grid item xs={9}>
                                                        {rows && rows.length ? (
                                                            <Grid container>
                                                                {rows.map((item,rowIdx) => {
                                                                    const {key, label} = item;
                                                                    if (label) {
                                                                        return (
                                                                            <Grid item xs={4} key={rowIdx} style={{ paddingBottom: '10px', textAlign: 'left' }}>
                                                                                <Typography variant="body1" style={{ paddingBottom: '5px' }}>
                                                                                    <strong>{label}</strong>
                                                                                </Typography>
                                                                                <Typography variant="body1">
                                                                                    <span>{readOnlyValueGenerator(item)}</span>
                                                                                </Typography>
                                                                            </Grid>
                                                                        );
                                                                    }
                                                                    return null;
                                                                })}
                                                            </Grid>
                                                        ) : null}
                                                    </Grid>
                                                ) : null}
                                            </Grid>
                                        </Grid>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails className={classes.details}>
                                        {rows && rows.length ? (
                                            <Grid
                                                container
                                                direction="row"
                                                spacing={3}
                                            >
                                                {rows.map((item, rowIdx) => {
                                                    const {key, label} = item;
                                                    if (label) {
                                                        return (
                                                            <Grid item xs={4} key={rowIdx} style={{ paddingBottom: '10px', textAlign: 'left' }}>
                                                                <Typography variant="body1" style={{ paddingBottom: '5px' }}>
                                                                    <strong>{label}</strong>
                                                                </Typography>
                                                                {!editView ? (
                                                                    <Typography variant="body1">
                                                                        <span>{readOnlyValueGenerator(item)}</span>
                                                                    </Typography>
                                                                ) : (
                                                                    <RenderInput
                                                                        item={item}
                                                                        disabled={item.disabled || false}
                                                                        value={fieldData[idx][rowIdx].value}
                                                                        data={graphqlData}
                                                                        handleFilterChange={(newVal) => handleFieldChange(idx, rowIdx, newVal, idPrefix)}
                                                                        handleInputChange={(e) => handleFieldChange(idx, rowIdx, e.target.value, idPrefix)}
                                                                        handleSwitchChange={handleSwitchChange}
                                                                        setInputs={setInputs}
                                                                        inputs={inputs}
                                                                    />
                                                                )}
                                                            </Grid>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </Grid>
                                        ) : null}
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            );
                        })}
                    </Grid>
                ) : null}
            </Grid>
        </Box>
    );
}

export default ExpanderList;